// extracted by mini-css-extract-plugin
export default {"root":"ClientSearch_root__fhn1N","helper-text":"ClientSearch_helper-text__oNaLN"};